import defaultTheme from '@clasohlson/co-ui-components/styles/theme';

let customTheme = { ...defaultTheme };
customTheme.colors.primary = '#78d7fa';
customTheme.colors.primaryDarken = '#088dc1';
customTheme.colors.text = '#000000';
customTheme.colors.lightGray = '#f7f7f7';
customTheme.colors.mediumGray = '#eaeaea';
customTheme.misc.buttonBorderRadius = '3px';

export default customTheme;
